import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: {
            'ar': ['ar-EG'],
            'cs': ['cs-CZ'],
            'de': ['de-DE'],
            'es': ['es-ES'],
            'fr': ['fr-FR'],
            'he': ['he-IL'],
            'hu': ['hu-HU'],
            'id': ['id-ID'],
            'in': ['in-ID'],
            'it': ['it-IT'],
            'ja': ['ja-JP'],
            'km': ['km-KH'],
            'ko': ['ko-KR'],
            'my': ['my-MM'],
            'nb': ['nb-NO'],
            'nl': ['nl-NL'],
            'pl': ['pl-PL'],
            'pt': ['pt-BR'],
            'ro': ['ro-RO'],
            'ru': ['ru-RU'],
            'sl': ['sl-SI'],
            'sv': ['sv-SE'],
            'th': ['th-TH'],
            'tr': ['tr-TR'],
            'vi': ['vi-VN'],
            'zh': ['zh-CN'],
            'default': ['en-GB']
        },

        returnEmptyString: false,

        debug: true,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        detection: { // Options for detecting users language
            // order and from where user language should be detected
            order: ['navigator', 'querystring', 'cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'], // Use navigator for testing

            // keys or params to lookup language from
            lookupQuerystring: 'lng',
            lookupCookie: 'i18next',
            lookupLocalStorage: 'i18nextLng',
            lookupFromPathIndex: 0,
            lookupFromSubdomainIndex: 0,

            // cache user language on
            caches: ['localStorage', 'cookie'],
            excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

            // optional expire and domain for set cookie
            cookieMinutes: 10,
            cookieDomain: 'myDomain',

            // optional htmlTag with lang attribute, the default is:
            htmlTag: document.documentElement
        },

        backend: {
            loadPath: 'wwwroot/public/locales/{{lng}}/{{ns}}.json'
        }
    });


export default i18n;